import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

/**
 * Vertical timeline composed of one TimelineItem per event. The visual
 * port of MAFA's `.timeline` block: a square accent node on a vertical
 * line, with a card next to it. We expose two slots — `node` (an icon
 * name) and `children` (the card body) — so callers don't have to know
 * the exact CSS classes.
 */

export function Timeline({ children }: { children: ReactNode }) {
  return <div className="timeline">{children}</div>;
}

type TimelineItemProps = {
  icon: IconName;
  title: string;
  meta?: ReactNode;
  when: string;
  summary?: string;
  footer?: ReactNode;
  showLine?: boolean;
  onClick?: () => void;
};

export function TimelineItem({
  icon,
  title,
  meta,
  when,
  summary,
  footer,
  showLine,
  onClick,
}: TimelineItemProps) {
  return (
    <div className="tl-item" onClick={onClick}>
      <div className="tl-rail">
        <div className="tl-node">
          <Icon name={icon} />
        </div>
        {showLine && <div className="tl-line" />}
      </div>
      <div className="tl-card">
        <div className="tl-top">
          <span className="tl-type">{title}</span>
          {meta}
          <span className="tl-when">{when}</span>
        </div>
        {summary && <div className="tl-sum">{summary}</div>}
        {footer && <div className="tl-meta">{footer}</div>}
      </div>
    </div>
  );
}
